import { NgModule } from '@angular/core';
import { Lib1Component } from './lib1.component';
import { CompComponent } from './comp/comp.component';

@NgModule({
  declarations: [Lib1Component, CompComponent],
  imports: [
  ],
  exports: [Lib1Component]
})
export class Lib1Module { }
